import React from "react";
import ReactDOM from "react-dom/client";

import { initDatadogRum } from "igfd-commons/src/monitoring";
import { installPreloadErrorHandler } from "igfd-commons/src/utils/preloadErrorHandler";

import { App } from "./App";
import { datadogRumConfig } from "./environment/monitoring";

initDatadogRum(datadogRumConfig);

installPreloadErrorHandler();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
